// src/components/LayoutWithBanners.tsx
import { ReactNode } from 'react';
import { BannerDisplay } from './BannerDisplay';

interface LayoutWithBannersProps {
  children: ReactNode;
  pageLocation: string;
  showTopBanner?: boolean;
  showBottomBanner?: boolean;
  showLeftSidebar?: boolean;
  showRightSidebar?: boolean;
  className?: string;
}

export function LayoutWithBanners({
  children,
  pageLocation,
  showTopBanner = true,
  showBottomBanner = true,
  showLeftSidebar = true,
  showRightSidebar = true,
  className = ''
}: LayoutWithBannersProps) {
  return (
    <div className={`min-h-screen bg-gray-50 ${className}`}>
      {/* Top Banner */}
      {showTopBanner && (
        <div className="w-full bg-white border-b border-gray-200" style={{ marginTop: '0px !important' }}>
          <div className="max-w-7xl mx-auto px-4 py-4" style={{ marginTop: '0px !important' }}>
            <div style={{ marginTop: '0px !important' }}>
              <BannerDisplay 
                pageLocation={pageLocation} 
                positionKey="top-banner" 
              />
            </div>
          </div>
        </div>
      )}

      {/* Main Content with Sidebars */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Left Sidebar - Square Banner without Frame */}
          {showLeftSidebar && (
            <aside className="lg:col-span-2">
              <div className="sticky top-20" style={{ top: '5rem' }}>
                <BannerDisplay 
                  pageLocation={pageLocation} 
                  positionKey="left-sidebar" 
                />
              </div>
            </aside>
          )}

          {/* Main Content - Full Width Available */}
          <main className={`${
            showLeftSidebar && showRightSidebar 
              ? 'lg:col-span-8'  
              : showLeftSidebar || showRightSidebar 
                ? 'lg:col-span-10'  
                : 'lg:col-span-12'
          }`}>
            {children}
          </main>

          {/* Right Sidebar - Much smaller, pushed very far left, with extended sticky scroll */}
          {showRightSidebar && (
            <aside className="lg:col-span-2 flex justify-start pl-8">
              <div className="sticky-container" style={{ height: 'calc(100vh - 6rem)', position: 'relative' }}>
                <div 
                  className="sticky-banner transform scale-110" 
                  style={{ 
                    position: 'sticky',
                    top: '8rem',
                    width: '200%',
                    maxWidth: '200px',
                    alignSelf: 'flex-start',
                    transformOrigin: 'top left'
                  }}
                >
                  <BannerDisplay 
                    pageLocation={pageLocation} 
                    positionKey="right-sidebar" 
                  />
                </div>
              </div>
            </aside>
          )}
        </div>
      </div>

      {/* Bottom Banner */}
      {showBottomBanner && (
        <div className="w-full bg-white border-t border-gray-200 mt-8">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <BannerDisplay 
              pageLocation={pageLocation} 
              positionKey="bottom-banner" 
            />
          </div>
        </div>
      )}
    </div>
  );
}